import { render, staticRenderFns } from "./AlternativesViewDeleterDialog.vue?vue&type=template&id=52204de3&scoped=true"
import script from "./AlternativesViewDeleterDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativesViewDeleterDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlternativesViewDeleterDialog.vue?vue&type=style&index=0&id=52204de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52204de3",
  null
  
)

export default component.exports